import { TranslationKeys as CoreTranslations } from '@pascal/pascal-core';

const GameTranslationKeys = {
  TopWinners: 'TOP_WINNERS',
  History: 'BET_HISTORY',
  Result: 'RESULT',
  LiveBets: 'LIVE_BETS',
  Statistics: 'STATISTICS',
  Info: 'INFO',
  FairnessModalTitle: 'FAIRNESS',
  ProvablyFairness: 'PROVABLY_FAIRNESS',
  Time: 'TIME',
  GameId: 'GAME_ID',
  Count: 'COUNT',
  TotalBet: 'TOTAL_BET',
  Game: 'GAME',
  PlayForReal: 'PLAY_FOR_REAL',
  Music: 'MUSIC',
  Sound: 'SOUND',
  WinterMode: 'WINTER_MODE',
  BlackMode: 'BLACK_MODE',
  PlayerId: 'PLAYER_ID',
  BetType: 'BET_TYPE',
  LastRounds: 'LAST_ROUNDS',
  Balance: 'BALANCE',
  All: 'ALL',
  Win: 'WIN',
  Lose: 'LOSE',
  MaximumWin: 'MAXIMUM_WIN',
  MinimumBet: 'MINIMUM_BET',
  MaximumBet: 'MAXIMUM_BET',
  Seconds: 'SECONDS',
  PlayNow: 'PLAY_NOW',
  Demo: 'DEMO',
  Play: 'PLAY',
  ResultId: 'RESULT_ID',
  Results: 'RESULTS',
  Pf: 'PF',
  Soon: 'SOON',
  Odd: 'ODD',
  Chat: 'CHAT',
  Highest: 'HIGHEST',
  Manual: 'MANUAL',
  Autoplay: 'AUTOPLAY',
  CreateNew: 'CREATE_NEW',
  AllIn: 'ALL_IN',
  Max: 'MAX',
  Min: 'MIN',
  AutoCashOut: 'AUTO_CASHOUT',
  Bet: 'BET',
  CashOut: 'CASHOUT',
  Cashed: 'CASHED',
  BetForNextRound: 'BET_FOR_NEXT_ROUND',
  Cancel: 'CANCEL',
  RoundId: 'ROUND_ID',
  CurrentBet: 'CURRENT_BET',
  GameResult: 'GAME_RESULT',
  BaseBet: 'BASE_BET',
  OnWin: 'ON_WIN',
  OnLoss: 'ON_LOSS',
  Increase: 'INCREASE',
  NumberOfRounds: 'NUMBER_OF_ROUNDS',
  StopIfLoss: 'STOP_IF_LOSS',
  StartAutoplay: 'START',
  StopAutoplay: 'STOP',
  YouHaveCashedOut: 'YOU_HAVE_CASHED_OUT',
  AutoplayHasStopped: 'AUTOPLAY_HAS_STOPPED',
  YourWin: 'YOUR_WIN',
  Me: 'ME',
  MaxAutoCashOut: 'Maximum auto cash out odd is {{InValidMaxAutoCashOutOdd}}',
  MinIncrease: 'MIN_MULTIPLIER',
  MaxIncrease: 'MAX_MULTIPLIER',
  StopNumberOfRounds: 'MIN_NUMBER_OF_ROUNDS',
  StopMaxNumberOfRounds: 'MAX_NUMBER_OF_ROUNDS',
  StopIfLossNot: 'MIN_LOSE_AMOUNT',
  Rtp: 'RTP',
  MaxWinNote: 'MAX_WIN_NOTE',
  WinMoreWith: 'WIN_MORE_WITH',
  RtpPopUpDesc: 'RTP_POPUP_DESC',
  PlayAndWin: 'PLAY_AND_WIN',
  DontShowAgain: 'DONT_SHOW_AGAIN',
  Next: 'NEXT',
  NewFeature: 'NEW_FEATURE',
  CashOutFiftyDesc1: 'CASH_OUT_FIFTY_DESC_1',
  CashOutFiftyDesc2: 'CASH_OUT_FIFTY_DESC_2',
  YouWin: 'YOU_WIN',
  AutoBet: 'AUTO_BET',
  FairnessP1: 'FAIRNESS_P1',
  FairnessP2: 'FAIRNESS_P2',
  FairnessP3: 'FAIRNESS_P3',
  FairnessP4: 'FAIRNESS_P4',
  FairnessP5: 'FAIRNESS_P5',
  FairnessP6: 'FAIRNESS_P6',
  FairnessP7: 'FAIRNESS_P7',
  FairnessP8: 'FAIRNESS_P8',
  FairnessP9: 'FAIRNESS_P9',
  FairnessP10: 'FAIRNESS_P10',
  FairnessP11: 'FAIRNESS_P11',
  FairnessP12: 'FAIRNESS_P12',
  GameRulesP1: 'GAME_RULES_P1',
  GameRulesP2: 'GAME_RULES_P2',
  GameRulesP3: 'GAME_RULES_P3',
  GameRulesP4: 'GAME_RULES_P4',
  GameRulesP5: 'GAME_RULES_P5',
  GameRulesP6: 'GAME_RULES_P6',
  GameRulesP7: 'GAME_RULES_P7',
  GameRulesP8: 'GAME_RULES_P8',
  GameRulesP9: 'GAME_RULES_P9',
  GameRulesP15: 'GAME_RULES_P15',
  CancelationMessage1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage2: 'MALFUNCTION_MESSAGE_2',
  About: 'ABOUT',
  GameTypes: 'GAME_TYPES',
};

export const globalTranslationKeys = Object.assign(CoreTranslations, GameTranslationKeys);
